import React from 'react';

type Props = { isActive: boolean; onClick: () => void; zIndex?: number };

export function DimmerScreen(props: Props) {
  return (
    <div
      className="position-fixed"
      onClick={props.onClick}
      style={{
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.0)',
        zIndex: props.zIndex || 1,
        display: props.isActive ? 'block' : 'none',
      }}
    />
  );
}
